'use client';

import React, { useEffect, useState } from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
import { cn } from '@/shared/lib/classnames/cn';
import { bottomBarVariants } from '../model/variants';
import type { BottomBarProps } from '../model/types';
export const BottomBar: React.FC<BottomBarProps> = ({
  children,
  variant,
  align,
  isVisible = true,
  disableAnimation = false
}) => {
  const [shouldRender, setShouldRender] = useState(isVisible || disableAnimation);
  const [isAnimating, setIsAnimating] = useState(disableAnimation || isVisible);
  useEffect(() => {
    if (disableAnimation) {
      setShouldRender(true);
      setIsAnimating(true);
      return;
    }
    let timer: ReturnType<typeof setTimeout>;
    if (isVisible) {
      setShouldRender(true);
      timer = setTimeout(() => {
        setIsAnimating(true);
      }, 50);
    } else {
      setIsAnimating(false);
      timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
    return () => clearTimeout(timer);
  }, [isVisible, disableAnimation]);
  if (!shouldRender) {
    return null;
  }
  return <div className={classNames(cn(bottomBarVariants({
    variant,
    align
  })), {
    'transition-all duration-300 ease-out will-change-transform': !disableAnimation,
    'translate-y-0 scale-100 opacity-100': !disableAnimation && isAnimating,
    'translate-y-full scale-95 opacity-0': !disableAnimation && !isAnimating
  })} style={!disableAnimation ? {
    transitionTimingFunction: isAnimating ? 'cubic-bezier(0.175, 0.885, 0.32, 1.275)' : 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: isAnimating ? '0.4s' : '0.3s'
  } : undefined} data-sentry-component="BottomBar" data-sentry-source-file="index.tsx">
      {children}
    </div>;
};